import { saveAuthSession } from './authSession';

/**
 * One-click sign-in as the shared guest account.
 *
 * The guest credential lives on the server: this calls `POST /api/auth/guest`, which
 * signs in with it and answers with the usual token pair. The client used to embed the
 * guest password directly, which published it to anyone who loaded the page — the same
 * leak the brand-profile admin password had (see journal #7 / #20).
 *
 * On success the token pair is stored in localStorage, exactly as a normal login does,
 * so the caller only has to reload into the app.
 */
export async function guestLogin(apiBaseUrl: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const response = await fetch(`${apiBaseUrl}/api/auth/guest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json().catch(() => ({}));

    if (response.ok && data?.token) {
      saveAuthSession(data);
      return { ok: true };
    }

    return { ok: false, error: data?.error || 'Guest login failed' };
  } catch {
    return { ok: false, error: 'Connection error. Please try again.' };
  }
}
